// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3sIGt","wrapper":"style_wrapper__1TKHv","primaryInfo":"style_primaryInfo__7xDRN","icon":"style_icon__32DgP"};